export const START_PAYMENT_TRANSACTION_LOADING = 'REDUX_SAGA_START_PAYMENT_TRANSACTION_LOADING';
export const START_PAYMENT_TRANSACTION_SUCCESS = 'REDUX_SAGA_START_PAYMENT_TRANSACTION_SUCCESS';
export const START_PAYMENT_TRANSACTION_ERROR = 'REDUX_SAGA_START_PAYMENT_TRANSACTION_ERROR';
export const RESET_PAYMENT_TRANSACTION = 'REDUX_SAGA_RESET_PAYMENT_TRANSACTION';

export const actionPostPaymentTransaction = (dispatch, token, customer, recaptchaToken) => {
    dispatch({ type: START_PAYMENT_TRANSACTION_LOADING, token, customer, recaptchaToken });
};

export const actionResetPaymentTransaction = (dispatch) => {
    dispatch({ type: RESET_PAYMENT_TRANSACTION });
};